export const AUTH_QUERY_KEYS = {
  all: ['auth'],
  currentUser: ['auth', 'currentUser'],
}
